import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow",
  "use": "arrow-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"arrow\"><path d=\"M9.9 8.1l7.9 7.9-7.9 7.9L12 26l10-10L12 6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol